import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import TypographySpanWithI18N from 'shared/components/TypographySpanWithI18N';
import styles from './LabelValuePair.module.scss';

export interface ILabelValueProps {
  id: string;
  label: string;
  value: string | undefined;
  labelSx?: any;
  valueSx?: any;
}

const LabelValue: React.FC<ILabelValueProps> = ({
  id,
  label,
  value,
  labelSx,
  valueSx,
  ...props
}) => {
  return (
    <div className={styles.labelContainer}>
      <span className={styles.label}>
        <TypographySpanWithI18N
          className='kfic2-bodyText'
          id={`${id}-label`}
          data-testid={`${id}-label`}
          i18nKey={label}
          textSuffix={':'}
          sx={{
            mr: 1,
            mb: 1,
            ...labelSx,
          }}
        />
      </span>
      <span
        className={styles.value}
        aria-label={value}
        title={value}
        id={id}
        data-testid={id}
      >
        {value}
      </span>
    </div>
  );
};

export default LabelValue;
